import React, { useContext, useEffect } from "react";
import utils from "../../../../../../utils";
import values from "../../../../../../values";
import Context from "../../../../../../context";
import Cookies from "js-cookie";
import TitleLine from "../../../../../../components/TitleLine";

import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { useFormik } from "formik";
import {
  ICreateAndUpdateDriver,
  IPlateNumber,
} from "../../../../../../types/driver.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomInput,
  CustomView,
  PlateNumber,
} from "../../../../../../components";

import * as Yup from "yup";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import validations from "../../../../../../validations";
import PlateNumberr from "../../../../../../components/PlateNumberr";

type Props = {
  defaultValues: any;
  onSubmit: (event: ICreateAndUpdateDriver) => void;
};

const CompanyDriverInformation = (props: Props) => {
  const { loading, setShowModal, updateDriver, selectedDriver } =
    React.useContext(Context.DriverScreen);
  const [plateNumber, setPlateNumber] = React.useState<
    IPlateNumber | undefined
  >({});
  const [selectedGender, setSelectedGender] = React.useState<IItem | undefined>(
    gender.filter((item) => {
      return item.value === props?.defaultValues?.gender;
    })[0]
  );
  const [selectedMarital, setSelectedMarital] = React.useState<
    IItem | undefined
  >(props?.defaultValues?.marital);
  const companyIdentify = Cookies.get(values.constants.USER.IDENTIFY);
  const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    province: "",
    city: "",
    gender: "",
    marital: "",
  });

  useEffect(() => {
    setPlateNumber(props?.defaultValues?.plateNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------

  // const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
  //   api.get.common.getAllProvince()
  // );
  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, selectedProvince],
  //   () =>
  //     api.get.common.getAllCity({
  //       provinceCode: selectedProvince
  //         ? selectedProvince?.Code
  //         : getAllProvince?.data?.result?.find(
  //             (item: IProvinceItem) =>
  //               item?._id ===
  //               props.defaultValues?.schoolDriverInformation?.province
  //           ).Code,
  //     })
  // );

  // useEffect(() => {
  //   setSelectedProvince(
  //     getAllProvince?.data?.result?.find(
  //       (item: IProvinceItem) =>
  //         item?._id === props.defaultValues?.schoolDriverInformation?.province
  //     )
  //   );
  // }, [props.defaultValues, getAllProvince?.data?.result]);

  // useEffect(() => {
  //   setSelectedCity(
  //     getAllCity?.data?.result?.find(
  //       (item: ICityItem) =>
  //         item?._id === props.defaultValues?.schoolDriverInformation?.city
  //     )
  //   );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getAllCity?.data?.result]);

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateDriver>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: props?.defaultValues?.phoneNumber,
      firstName: props?.defaultValues?.firstName,
      lastName: props?.defaultValues?.lastName,
      nationalCode: props?.defaultValues?.nationalCode,
      address: props?.defaultValues?.address,
      car: props?.defaultValues?.car,
      carColor: props?.defaultValues?.carColor,
    },
    validationSchema: Yup.object({
      address: validations.yupValidations.address,
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      phoneNumber: validations.yupValidations.phoneNumber,
      nationalCode: validations.yupValidations.nationalCode,
    }),
    onSubmit: (values: ICreateAndUpdateDriver, { setSubmitting }) => {
      if (!companyIdentify) return utils.errorHandler(9013);
      const formValues: ICreateAndUpdateDriver = {
        _id: selectedDriver?._id,
        ...values,
      };
      updateDriver!(formValues);
    },
  });

  const submitHandler = () => {
    // setDropDownErrors(dropDownErrorsList);

    formik.submitForm();
  };

  const { userInfo } = useContext(Context.UserScreen);

  // const provinceFiltered = getAllProvince?.data?.result?.filter((item: any) =>
  //   userInfo?.companyInformation?.province?.includes(item?._id)
  // );
  // const cityFiltered = getAllCity?.data?.result?.filter((item: any) =>
  //   userInfo?.companyInformation?.city?.includes(item?._id)
  // );

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <form onSubmit={submitHandler}>
      <CustomView.Container className="update-form-content">
        <TitleLine title="اطلاعات راننده" />
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="firstName"
              id="firstName"
              label="نام"
              value={formik.values.firstName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.firstName && formik.touched.firstName}
              errorText={formik.errors.firstName}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="lastName"
              id="lastName"
              label="نام خانوادگی"
              value={formik.values.lastName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.lastName && formik.touched.lastName}
              errorText={formik.errors.lastName}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="nationalCode"
              id="nationalCode"
              label="کدملی"
              value={formik.values.nationalCode}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.nationalCode && formik.touched.nationalCode}
              errorText={formik.errors.nationalCode}
              maxLength={10}
            />
          </CustomView.Column>

          <CustomView.Column medium={6} className="form-colum dropdown">
            <CustomInput
              id="phoneNumber"
              name="phoneNumber"
              label="شماره موبایل"
              value={formik.values.phoneNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.phoneNumber && formik.touched.phoneNumber}
              errorText={formik.errors.phoneNumber}
              maxLength={11}
            />
          </CustomView.Column>
        </CustomView.Row>

        {/* <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">استان</label>
            <CustomDropdownSearch
              items={provinceFiltered}
              itemName="Name"
              defaultItem={selectedProvince}
              onSelectItem={(event: IProvinceItem) => {
                setSelectedCity(undefined);
                setSelectedProvince(event);
                setDropDownErrors({ ...dropDownErrors, province: "" });
              }}
              placeHolder="انتخاب استان"
              isSearch
            />
            <div className="error">
              {dropDownErrors.province !== "" && dropDownErrors.province}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">شهر</label>
            <CustomDropdownSearch
              items={cityFiltered}
              itemName="Name"
              defaultItem={selectedCity}
              onSelectItem={(event: ICityItem) => {
                setSelectedCity(event);
                setDropDownErrors({ ...dropDownErrors, city: "" });
              }}
              placeHolder="انتخاب شهر"
              isSearch
            />
            <div className="error">
              {dropDownErrors.city !== "" && dropDownErrors.city}
            </div>
          </CustomView.Column>
        </CustomView.Row> */}

        {/* <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">جنسیت</label>

            <CustomDropdownSearch
              items={gender}
              itemName="name"
              placeHolder="انتخاب جنسیت"
              defaultItem={selectedGender}
              onSelectItem={(event: any) => {
                setSelectedGender(event);
                setDropDownErrors({ ...dropDownErrors, gender: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.gender !== "" && dropDownErrors.gender}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">وضعیت تاهل</label>

            <CustomDropdownSearch
              items={marital}
              itemName="name"
              placeHolder=" انتخاب وضعیت تاهل"
              defaultItem={selectedMarital}
              onSelectItem={(event: any) => {
                setSelectedMarital(event);
                setDropDownErrors({ ...dropDownErrors, marital: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.marital !== "" && dropDownErrors.marital}
            </div>
          </CustomView.Column>
        </CustomView.Row>
 */}
        {/* <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="kartNumber"
              id="kartNumber"
              label="شماره کارت"
              value={formik.values.kartNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.kartNumber && formik.touched.kartNumber}
              errorText={formik.errors.kartNumber}
              maxLength={16}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="shabaNumber"
              id="shabaNumber"
              label="شماره شبا"
              value={formik.values.shabaNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.shabaNumber && formik.touched.shabaNumber}
              errorText={formik.errors.shabaNumber}
              maxLength={24}
              isShaba
            />
          </CustomView.Column>
        </CustomView.Row> */}
        <CustomView.Row className="form-row">
          <CustomView.Column medium={12} className="form-colum">
            <CustomInput
              name="address"
              id="address"
              label="آدرس"
              value={formik.values.address}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.address && formik.touched.address}
              errorText={formik.errors.address}
            />
          </CustomView.Column>
        </CustomView.Row>
        <TitleLine title="اطلاعات خودرو" />
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="car"
              id="car"
              label="نوع خورو"
              value={formik.values.car}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.car && formik.touched.car}
              errorText={formik.errors.car}
              placeHolder={"مثال: پراید"}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="carColor"
              id="carColor"
              label="رنگ خودرو"
              value={formik.values.carColor}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.carColor && formik.touched.carColor}
              errorText={formik.errors.carColor}
              placeHolder={"مثال: سفید"}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <label className="form-label">شماره‌ی پلاک</label>
            <PlateNumber
              editor
              onChange={(event: IPlateNumber) => {
                setPlateNumber(event);
                setDropDownErrors({ ...dropDownErrors, plateNumber: "" });
              }}
              tagNum={plateNumber as IPlateNumber}
            />
            <div className="error">
              {dropDownErrors.plateNumber !== "" && dropDownErrors.plateNumber}
            </div>{" "}
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={loading}
              onClick={() => setShowModal!("NONE")}
              title="لغو"
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={loading}
              onClick={submitHandler}
              title="ویرایش راننده"
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

const gender: IItem[] = [
  { _id: "0", name: "مرد", value: "MALE" },
  { _id: "1", name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default CompanyDriverInformation;
